import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { materialDefinitionKeys } from 'core/query-client/keys';
import { executeRequest } from 'core/utils/backend-service';
import { getMaterialDefinitions, SortParam } from '../material-definitions.service';

export const useMaterialDefinitionsList = (sort?: SortParam) => {
    const {
        data: materials = [],
        isLoading,
        isFetching,
    } = usePocQuery({
        queryKey: materialDefinitionKeys.list(sort),
        queryFn: () => executeRequest(() => getMaterialDefinitions(0, 200, sort)),
    });

    return { materials, isLoading: isLoading || isFetching };
};
